import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation, useSearchParams } from 'react-router-dom';

export function PrivateRoute(props) {
  const auth = useSelector((state) => state.auth);
  const currentProjectId = useSelector((state) => state.project.currentId);
  const project = useSelector((state) => {
    if (state.project.currentId && state.project.byId && state.project.byId[state.project.currentId]) {
      return state.project.byId[state.project.currentId];
    } else {
      return undefined;
    }
  });

  const [searchParams] = useSearchParams();
  const isSeamlessLogin = searchParams.has('id') && searchParams.has('hash');
  const projectIdFromUrl = searchParams.get("projectId");
  const location = useLocation();

    if (!auth?.user && !isSeamlessLogin) {
        const attemptedUrl = encodeURIComponent(location.pathname + location.search);

        return <Navigate to={`/login?redirectUrl=${attemptedUrl}`} replace />;
    }

  // Allow access if:
  // 1. We have a current project loaded
  // 2. We're on select_project page
  // 3. We have projectId in URL (project switching in progress)
  // 4. We have currentProjectId set (even if project data not loaded yet)
  if (project || location.pathname === "/select_project" || projectIdFromUrl || currentProjectId) {
    return <Outlet context={{ auth, project }}/>;
  } else if (location.pathname === "/account" || location.pathname === "/manage-subscription" || (location.state?.projectName && location.state?.telegramId)) { // check location state as well in case we have just transferred project
    return <Outlet context={{ auth }}/>;
  } else {
    return <Navigate to="/select_project" replace />;
  }
}
